<header class="vnp-header" mat-dialog-title>
  <span class="vnp-header-icone">
    <mat-icon class="material-symbols-outlined">receipt_long</mat-icon>
  </span>
  <div class="vnp-header-texto">
    <h2 class="vnp-titulo">Vincular nota fiscal ao pedido {{ data.codigoPedido }}</h2>
    <div class="vnp-subtitulo">{{ subtitulo || 'Para entrar em Pedido Faturado, o pedido precisa de uma NF-e vinculada.' }}</div>
  </div>
  <button mat-icon-button type="button" class="vnp-header-btn icon-mat-symbols-btn" (click)="alternarTamanho()"
    [matTooltip]="isMaximizado ? 'Restaurar' : 'Maximizar'" [attr.aria-label]="isMaximizado ? 'Restaurar' : 'Maximizar'">
    <mat-icon class="material-symbols-outlined">{{ isMaximizado ? 'close_fullscreen' : 'open_in_full' }}</mat-icon>
  </button>
  <!-- Durante o vínculo o fechar fica desabilitado, sem aviso de espera: o spinner está no "Vincular" da nota. -->
  <span class="vnp-header-acao" matTooltip="Fechar" [matTooltipDisabled]="vinculando">
    <button mat-icon-button type="button" class="vnp-header-btn icon-mat-symbols-btn" aria-label="Fechar"
      [disabled]="vinculando" (click)="cancelar()">
      <mat-icon class="material-symbols-outlined">close</mat-icon>
    </button>
  </span>
</header>

<mat-dialog-content class="vnp-conteudo">
  <app-seletor-nota-fiscal [idCompra]="data.idCompra" [ocupado]="vinculando" (notaEscolhida)="vincular($event)"
    (fornecedorCarregado)="nomeFornecedor = $event">
  </app-seletor-nota-fiscal>
</mat-dialog-content>

<mat-dialog-actions class="vnp-rodape">
  <span class="vnp-progresso">Sem nota vinculada o pedido permanece em {{ data.nomeEtapaOrigem }}</span>
  <button mat-stroked-button type="button" class="btn-secondary" [disabled]="vinculando" (click)="cancelar()">Cancelar</button>
</mat-dialog-actions>
